export default {
  home: {
    describe1: "Kullanmaya hoş geldiniz",
    describe2: "Bırakın dünya sadece parmaklarınızın ucunda olsun",
    describe3: "Mükemmel bir platformlar arası çözüme sahiptir. Bir ağ platformuna dayanır ve dağıtılmış bölgesel yönetim teknolojisini benimser. Çeşitli multimedya kaynaklarını etkili bir şekilde entegre edebilir ve programların uzaktan üretimini, yayınlanmasını ve yönetimini gerçekleştirebilir."
  },
  app: {
    more: "Daha fazlasını gör",
    LogOut: "Oturumu kapat",
    AddMaterial: "Yeni Malzemeler",
    CreateRelease: "Yeni Sürüm",
    AddTerminal: "Terminal Ekle",
    CreateAccount: "Yeni bir hesap oluştur",
    Percent: "İndirme ilerlemesi",
    ReleaseSchedule: "Sürüm ilerlemesi",
    retransmission: "Yeniden yükle",
    AllRetransmission: "Tümünü Yeniden İlet",
    ClearanceToComplete: "Temizle Tamamlandı",
    RemoveAll: "Tümünü Temizle"
  },
  basics: {
    Cancel: "İptal etmek",
    Confirm: "Onaylamak",
    en: "İngilizce",
    zh: "Çince",
    PleaseSelect: "Lütfen seçin",
    PleaseInput: "Lütfen içeriği girin",
    materialCatalogue: "Malzeme Kataloğu",
    structureGrouping: "Organizasyon Yapısı Gruplaması",
    inStreamType: "Ara Bölüm Türü"
  },
  public: {
    search: "Lütfen arama anahtar sözcüğünü girin"
  },
  router: {
    help: "yardım",
    material: "Malzeme yönetimi",
    programme: "Program yönetimi",
    editProgramme: "Program düzenleme",
    publishProgramme: "Gelişmiş yayınlama",
    terminal: "Terminal yönetimi",
    check: "Denetim yönetimi",
    log: "Günlük yönetimi",
    logLogin: "Giriş günlüğü",
    logOperation: "Operasyon günlüğü",
    logTerminal: "Terminal günlüğü",
    seniorManagement: "Gelişmiş yönetim",
    userManage: "Kullanıcı yönetimi",
    RoleManage: "Rol yönetimi",
    systemLayout: "Sistem ayarları",
    nodeManage: "Düğüm yönetimi",
    reviewSet: "Denetim ayarları",
    softwareLicence: "Yazılım Lisanslama"
  },
  device: {},
  explorer: {
    clickUpload: "Dosyayı buraya sürükleyin veya <em>Yükle'yi tıklayın</em>",
    sizeLimit: "tek dosya aşılmamalı",
    video: "Video",
    picture: "Resim",
    uploadFiles: "Dosyayı yükle",
    newFolder: "Yeni bir klasör oluştur",
    deleteFiles: "Dosyayı sil",
    materialAll: "Tüm görüntüler yüklendi",
    materialsLoaded: "Daha fazla çekim yükle'ye tıklayın",
    move: "taşınmak",
    copy: "kopyala",
    delete: "Silmek",
    all: "Tümünü seç",
    name: "isim",
    resolution: "çözünürlük",
    fileSize: "Dosya boyutu",
    creationTime: "Yaratılış zamanı",
    operate: "işletmek",
    FolderName: "Klasör adı",
    deleteFile: "Mevcut Çince kısmını silecek miyim?",
    BackEdit: "Program düzenleyiciye dön",
    FileMove: "Dosya hareketi",
    FileCopy: "Dosya kopyalama",
    StartAll: "Hepsini başlat",
    StopAll: "Hepsini durdur",
    EmptyFinish: "Boşaltma tamamlandı",
    CancelAll: "Tümünü iptal et",
    NoFiles: "Hiçbir dosya yüklenmedi",
    Status: "durum",
    Check: "Görüş",
    Stop: "Durdur şunu",
    Start: "Başlamak",
    Cancel: "İptal etmek",
    finish: "sona ermek"
  },
  log: {
    export: "Cihazı seçin",
    selectDevice: "Cihaz SN'si",
    deviceSn: "Çalışma süresi",
    operateTime: "Kullanıcıyı manipüle etme",
    operateUser: "işlev",
    function: "Tanım",
    describe: "Tarih aralığı",
    dateArr: "Başlangıç ​​tarihi",
    startDate: "Bitiş tarihi",
    endDate: "Sor",
    search: "Lütfen bilgi almak için bir cihaz seçin",
    searchTips: "Lütfen bilgi almak için bir cihaz seçin",
    loadingTips: "Günlükler alınıyor, lütfen daha sonra",
    no: "numaralama",
    content: "içerik",
    operateObj: "İşlenenler",
    operateContent: "Operasyonel bilgiler",
    selectTips1: "Yalnızca son üç aya ait veriler sorgulanabilir",
    searchTips1: "Bir terminal seçin, zaman aralığını belirleyin ve sorguyu gerçekleştirin",
    exportTips: "yalnızca sorgu zaman aralığındaki verileri dışa aktar"
  },
  login: {
    Login: "Giriş yapmak",
    memberRegister: "Şimdi kaydolun",
    ForgetThePassword: "Şifrenizi mi unuttunuz?",
    NoLogin: "Yedi gün boyunca giriş yok",
    verification: "Lütfen bir doğrulama kodu girin",
    account: "Lütfen hesabınızı girin",
    password: "Lütfen şifrenizi girin"
  },
  manage: {},
  review: {
    Screenshot: "Organizasyon yapısı",
    ProgramName: "Çözünürlük",
    Structure: "Yaratılış zamanı",
    Resolution: "Operasyon",
    CreationTime: "Gözden geçirmek",
    operate: "işletmek",
    Review: "Gözden geçirmek",
    Check: "Görüş",
    ProgramMaterial: "Program materyali",
    ProgramPreview: "Program önizlemesi",
    ReviewContent: "Lütfen incelenecek içeriği girin",
    Approved: "İncelemeyi geçti",
    RejectReview: "İncelemeyi reddet",
    DeleteAll: "Tümünü silmeyi onaylıyor musunuz?",
    Name: "İsim",
    Size: "Boyut",
    Preview: "Önizleme",
    ProgramReview: "Program incelemesi",
    ReasonRefusal: "Lütfen ret nedenini giriniz!",
    number: "Sürüm numarası seçilmedi",
    review: "Denetim",
    enterKey: "Lütfen bir anahtar kelime girin",
    screenshot: "Ekran görüntüsü",
    name: "isim",
    group: "kurum",
    createTime: "Gönderim zamanı",
    publisher: "Yayıncı",
    check: "Görüş",
    pass: "Geçti",
    reject: "reddetmek",
    materialCheck: "İçerik incelemesi",
    pleaseInputContent: "Lütfen incelemenin içeriğini girin",
    approve: "Denetimi geçmek",
    rejectReview: "İncelemeyi reddet",
    releaseReview: "Bir inceleme yayınlayın",
    resonForReject: "Lütfen reddetme nedenini girin",
    all: "Tümü",
    waitReview: "İncelenecek",
    approves: "Geçmek",
    selectTips: "Lütfen en az bir çekim seçin",
    selectTips1: "Takip numarası seçilmedi",
    deleteTips: "Tüm silme işlemleri onaylansın mı?",
    deleteRecord: "Kayıtları sil",
    singleNo: "Sayı",
    loop: "dolaşıma sokmak",
    timming: "zamanlama",
    instream: "kırma",
    noAdap: "Uyarlanabilir değil",
    adap: "Uyarlanabilir ekran boyutu"
  },
  schedule: {
    Screenshot: "Program adı",
    ProgramName: "Organizasyon yapısı",
    Structure: "Çözünürlük",
    Resolution: "Yaratılış zamanı",
    CreationTime: "Operasyon",
    operate: "işletmek",
    AllLoaded: "Daha fazla malzeme yüklemek için tıklayın",
    materialsLoaded: "Yeni program +",
    NewProgram: "Şu anda seçili olan programı kalıcı olarak silmek istiyor musunuz?",
    DelProgram: "Medyayı sil",
    DeleteMedia: "Ekran görüntüsü",
    loop: "Döngü",
    timpingPlay: "Zamanlanmış oynatma",
    emerPlay: "Acil durum ekleme",
    releaseRecord: "Sürüm Notları",
    releaseMan: "Sürüm yönetimi",
    playNo: "Takip numarasını yayınlayın",
    group: "kurum",
    releaseType: "Serbest bırakma türü",
    releaseNow: "Hemen yayınla",
    releaseTim: "Piyasaya sürülmüş",
    publisher: "Yayıncı",
    review: "Denetim",
    pedReview: "İncelenecek",
    noReview: "Denetim yok",
    noPass: "Geçilmedi",
    pass: "Geçti",
    waitRelease: "Yayınlanacak",
    expird: "Günü geçmiş",
    detail: "detay",
    delete: "Silmek",
    deletePlay: "Gösteriyi sil",
    deletePlayTip: "Şu anda seçili olan programı kalıcı olarak silmek istiyor musunuz?",
    keyWords: "Lütfen bir anahtar kelime girin",
    noSelectTip: "Hiçbir sürüm kaydı seçilmedi",
    addPlay: "Gösteri ekle",
    selectProgram: "Program listesini seçin",
    delPro: "Gösteriyi sil",
    delProTip: "Tüm programları boşaltmak istiyor musunuz?",
    screenshot: "Ekran görüntüsü",
    proName: "Programın adı",
    structure: "Organizasyon yapısı",
    resolution: "çözünürlük",
    createTime: "Yaratılış zamanı",
    noProgram: "Şu anda hiçbir program yok",
    moveDown: "Daha fazla aşağıya taşınamaz",
    moveUp: "Artık ilerlemek mümkün değil",
    tips: "çabuk",
    playList: "çalma listesi",
    terminalList: "Terminallerin listesi",
    releaseProp: "Mülkleri yayınla",
    offline: "çevrimdışı",
    timimgPlan: "Planlanan sürümler",
    user: "kullanıcı",
    terminalName: "Terminalin adı",
    terminalState: "Cihaz durumu",
    publishSate: "Yayınlanma durumu",
    planModole: "Oynatma modu",
    playStrategy: "Politikayı yayınlayın",
    playPlan: "Çalma programı",
    playCount: "Oynatma sayısı",
    playsCount: "Ardışık oyun sayısı",
    pleaseSelect: "Lütfen seçin",
    playTimes: "Oynatma süresi",
    conPlayTime: "Sürekli oyun süresi",
    publish: "yayınlamak",
    customize: "Özelleştirmek",
    once: "bir kere",
    twice: "iki kere",
    treeTimes: "Üç kez",
    fourTimes: "Dört kez",
    fiveTimes: "Beş kez",
    sixTimes: "Altı kez",
    sevenTimes: "Yedi kez",
    eightTimes: "Sekiz kez",
    nineTimes: "Dokuz kez",
    tenTimes: "On kez",
    countTips: "Minimum tekrar sayısı 1'dir",
    pubSuccessTip: "Yayın başarılı oldu",
    selectTip1: "Lütfen en az iki program seçin",
    planPre: "Program önizlemesi",
    addPlayStep: "Planlama adımı ekleme",
    selectDate: "Bir tarih ve saat seçin",
    instreamResver: "Bir oturum içi planlama yapın",
    instreamNow: "Şimdi ekle",
    selectTimeTips: "Seçilen zaman geçerli saatten daha az olamaz",
    palyTime: "Oyun zamanı",
    selectStartTime: "Bir başlangıç ​​zamanı seçin",
    selectEndTime: "Bir bitiş zamanı seçin",
    conserLoop: "Ardışık döngü sayısı",
    validDate: "Son kullanma tarihi",
    date: "tarih",
    daily: "günlük",
    startTimeTips: "Başlangıç ​​zamanı bitiş zamanından sonra olamaz",
    endTimeTips: "Bitiş zamanı başlangıç ​​zamanından önce olamaz",
    startDateTips: "Başlangıç ​​tarihi bitiş tarihinden sonra olamaz",
    endDateTips: "Bitiş tarihi başlangıç ​​tarihinden önce olamaz",
    saveAplan: "En az bir plan tutun",
    check: "Görüş",
    planSize: "Program boyutu",
    planName: "Sürümün adı",
    leastTime: "Son kullanma tarihi"
  },
  system: {
    StructureName: "Organizasyon yapısı adı",
    Operate: "Operasyon",
    NewStructure: "Organizasyon yapısını ekleyin",
    DeleteStructure: "Organizasyon yapısını sil",
    Structure: "Organizasyon yapısı",
    MsgDeleteStructure: "Geçerli olanı kalıcı olarak silmek istiyor musunuz?",
    OnDevice: "Cihazı aç",
    OffDevice: "Cihazı kapat",
    inquiry: "Sen istiyor musun",
    on: "Aç",
    off: "Kapamak",
    slaveDevice: "Geçerli veya bağımlı cihaz",
    CloseCurrent: "Akımı kapat",
    CloseSlave: "Köleyi kapat",
    OpenCurrent: "Akımı aç",
    OpenSlave: "Köleyi aç",
    Account: "Hesap",
    Name: "İsim",
    Role: "Rol",
    Grade: "Seviye",
    Remark: "Notlar",
    RoleName: "Rol adı",
    Password: "Şifre",
    ConfirmPass: "Şifreyi onayla",
    Mail: "E-posta",
    DeleteUser: "Kullanıcıyı sil",
    DeleteRole: "Mevcut rolü kalıcı olarak silmek istiyor musunuz?",
    UnblockDevice: "Cihazın engellemesini kaldır",
    banDevice: "Cihazı engelle",
    Unblock: "Engellemeyi kaldır",
    ban: "Engellemek",
    BanTheCurrent: "Akımı engelle",
    BannedAffiliate: "Astları engelle",
    ReleaseTheCurrent: "Mevcut engellemeyi kaldır",
    ReleaseTheSubordinate: "Astların engellemesini kaldır",
    AddUser: "Kullanıcı ekle",
    ModifyUser: "Kullanıcıyı değiştir",
    inputPassword: "Lütfen onay şifresini girin",
    noPassword: "İki şifre tutarsız!",
    inputName: "Lütfen adınızı girin",
    RoleEmpty: "Rol adı boş olamaz",
    StructureEmpty: "Organizasyon yapısı boş olamaz",
    AccountEmpty: "Hesap boş olamaz",
    AccountAstrict: "Hesap yalnızca rakam, harf ve alt çizgi içerebilir!",
    AccountLength: "Lütfen hesap uzunluğunu 3~20 karaktere ayarlayın!",
    AccountRegistered: "Mevcut hesap kaydedildi, lütfen tekrar girin!",
    AddRole: "Yeni bir rol ekle",
    RoleRemark: "Rol notları",
    RightConfig: "İzin yapılandırması",
    DelRole: "Rolü sil",
    imageSize1: "Önerilen boyut 920x940 piksel PNG formatındaki resimdir",
    ReplacePicture: "Resmi değiştir",
    LoginLogo: "Giriş sayfası LOGO",
    imageSize2: "Önerilen boyut 360x80 piksel PNG formatındaki resimdir",
    SystemLogo: "Sistem sayfası LOGO",
    systemSettings: "Diğer sistem ayarları",
    configInformation: "Diğer yapılandırma bilgileri",
    DailyLimit: "Günlük başvuru limiti",
    UploadedType: "Yüklenen avatar görselleri yalnızca PNG formatında olabilir",
    UploadedSize: "Yüklenen avatar görselleri 2 MBı aşamaz!",
    addNode: "Düğüm eklendi",
    EnglishName: "İngilizce adı",
    ChineseName: "Çince adı",
    delNode: "Geçerli düğümü kalıcı olarak silmek istiyor musunuz?",
    AuthorizationType: "Yetkilendirme kodu türü",
    Model: "Modeli",
    Date: "Tarih",
    AuthorizationCode: "Yetki kodu",
    clearTips1: "Mevcut incelemeciyi temizlemek istiyor musunuz?",
    clearTips2: "Mevcut incelemeciyi temizlemek istiyor musunuz?",
    selectReviewer: "İnceleyeni seçin",
    noReviers: "İlgili denetim ayrıcalıklarına sahip olmayan personel",
    createTips: "Lütfen önce bir denetim hesabı oluşturun",
    sameReviwers: "Bir sonraki kuruluş aynı denetçiyi paylaşıyor",
    email: "posta kutusu",
    phone: "telefon",
    lastLogin: "Son giriş",
    remark2: "Şirket Adresi",
    resetPwd: "Şifrenizi sıfırlayın",
    subUser: "Alt kullanıcılar",
    NumOfTerminals: "Terminal sayısı",
    NumOfPro: "Program sayısı",
    editPwd: "Şifrenizi değiştirin",
    oriPwd: "Orijinal şifre",
    newPwd: "Yeni bir şifre oluştur",
    confirmPws: "Şifreyi belirleyin",
    modifyInfo: "Bilgileri değiştir",
    changeNick: "Takma adınızı değiştirin",
    changeEmail: "E-posta adresini değiştirin",
    personalCenter: "Kişisel Merkez",
    enterOriPwd: "Lütfen orijinal şifreyi girin",
    enterNewPwd: "Lütfen yeni bir şifre girin",
    confirmPwd: "Lütfen şifreyi onaylayın",
    enterNick: "Lütfen bir takma ad girin",
    pwdNoPass: "Şifre iki kez tutarsız",
    changePwdSucc: "Şifre değiştirildi",
    modiSuccess: "Değişiklik başarılı oldu",
    modiFail: "Değişiklik başarısız oldu",
    noSet: "Ayarlanmadı",
    PleaseInputEmail: "Lütfen e-posta adresinizi girin"
  },
  terminal: {
    treeTitle: "Organizasyon yapısı gruplaması",
    Details: "detay",
    online: "çevrimiçi",
    offline: "çevrimdışı",
    list: "liste",
    card: "çizelge",
    map: "harita",
    keyWord: "Lütfen bir anahtar kelime girin",
    refresh: "kızarmış",
    add: "a ekle",
    delete: "Silmek",
    deviceName: "Cihazın adı",
    remark: "açıklama",
    resolution: "çözünürlük",
    types: "tip",
    version: "Sürüm numarası",
    status: "durum",
    operate: "işletmek",
    edit: "tekrar düzeltme yapmak",
    loading: "Umutsuzca yükleniyor",
    allSelect: "Tüm formaları seç",
    selected: "Seçildi",
    selectAll: "Bu sayfa hepsini seçer",
    selectInMap: "Lütfen cihazın haritadaki konumunu seçin",
    structure: "Organizasyon yapısı",
    selectGroup: "Lütfen bir organizasyon yapısı seçin",
    selectSize: "Lütfen çözünürlük seçin",
    customize: "Özelleştirmek",
    followTerminal: "Terminali takip et",
    selectSn: "Lütfen SN seçin",
    deviceTip: "Cihaz adı boş olamaz",
    snTip: "SN boş olamaz",
    sizeTip: "Ekran çözünürlüğü boş olamaz",
    deviceType: "Cihaz türü",
    cancel: "İptal etmek",
    confirm: "Emin misin",
    delDevice: "Terminali sil",
    delDevTip: "Seçilen terminali kalıcı olarak silmek istiyor musunuz?",
    onlineTotal: "Çevrimiçi istatistikler",
    reboot: "Yeniden başlat",
    offscreen: "Ekranı kapat",
    onscreen: "Ekranı aç",
    timeTask: "Zamanlanmış komutlar",
    conBright: "Parlaklık ayarı",
    conVoice: "Ses ayarları",
    relay: "Röle anahtarları",
    timeZone: "Saat dilimi kalibrasyonu",
    signalChange: "Sinyal değiştirme",
    synScreen: "Çoklu ekran senkronizasyonu",
    timePlay: "Zamanlayıcı oynatma anahtarı",
    timeOn: "Zamanlanmış güç açma/kapama",
    wTip: "W çözünürlüğü boş",
    hTip: "H çözünürlüğü boş",
    xTip: "X konumu boş",
    yTip: "Y konumu boş",
    mapTip: "Tablo bilgilerini kontrol etmek için lütfen uzaklaştırın!!",
    selectTip: "Hiçbir cihaz seçilmedi",
    deviceDetail: "Cihaz ayrıntıları",
    playList: "çalma listesi",
    affi: "Çin Kurumu:",
    screenType: "Ekran tipi",
    boxTime: "Kutu Saati",
    noData: "Henüz veri yok",
    currTimeZone: "Geçerli saat dilimi",
    deviceLan: "Cihaz dili",
    deviceZoom: "Bellek alanı",
    runState: "Operasyonel durum",
    runTime: "Sürekli çalışma",
    lastHeart: "Son kalp atışı",
    timeOrder: "Zamanlanmış komutlar",
    comAddr: "Sunucu adresi",
    voice: "ses",
    birght: "parlaklık",
    no: "seri numarası",
    proName: "Programın adı",
    power: "Röleler",
    milRefresh: "otomatik olarak yenilemek için saniyeler",
    viewPho: "Orijinal resmi görüntüleyin",
    setTimeZone: "Saat dilimini ayarlayın",
    terminalUp: "Terminal yükseltmeleri",
    upType: "Yükseltme yöntemi",
    cloudUp: "Bulut yükseltmeleri",
    localUp: "Yerel dosya yükseltmesi",
    clickUp: "Yükle'ye tıklayın",
    name: "isim",
    type: "Modeli",
    verInfo: "Sürüm bilgisi",
    schedule: "İlerlemek",
    noUp: "Yükseltme gerekmez",
    waitStar: "Başlamasını bekleyin",
    downExc: "İstisnayı indir",
    downOK: "İndirme başarılı oldu",
    upTip: "Yükseltme işlemi tamamlandı, otomatik olarak yeniden başlatılacak",
    erroBack: "İstisna geri bildirimi",
    downError: "İndirme başarısız oldu",
    dowNum: "1 birim seçildi",
    upTips1: "Not: Veri kaybını önlemek için lütfen verilerinizi yedeklemeye dikkat edin, yükseltme tamamlandıktan sonra cihaz otomatik olarak yeniden başlayacaktır.",
    upTips2: "Lütfen gücü kaybetmeyin",
    upGr: "güncelleme",
    serverAddEdit: "Sunucu adresi değişikliği",
    serEdTit: "Uç noktayı yeni sunucuya taşıyın",
    newAddr: "Yeni sunucu adresi",
    test: "Test",
    user: "Hesap",
    psw: "şifre",
    remove: "göç etmek",
    conRes: "Yeniden başlatmayı onaylayın",
    conOnSc: "Açılış ekranını onaylayın",
    upTips3: "Lütfen bir zip veya apk dosyası kullanın",
    testOk: "Test geçti",
    testFail: "Test başarısız oldu",
    inputTips1: "Lütfen kullanıcı adınızı ve şifrenizi girin",
    opOk: "Operasyon başarılı oldu",
    mapTip1: "Lütfen cihazın yerini haritada işaretleyin",
    addDetail: "Ayrıntılar: adres",
    lng: "boylam",
    lat: "enlem",
    matTip2: "Adres alınamadı, lütfen daha sonra deneyin",
    orderTip: "Seçilen terminali yeniden başlattığınızdan emin misiniz?",
    orderTip1: "Seçilen terminalin ekranını kapatacağınızdan emin misiniz?",
    orderTip2: "Seçilen terminalin ekranını açtığınızdan emin misiniz?",
    scSetting: "Planlama ayarları",
    selectTip1: "Lütfen seçin",
    selectTip2: "Zamanlanmış komutlar eklendi",
    selectTip3: "Lütfen verileri işlemek için bir şablon seçin",
    conOrder: "Çalıştırma Talimatları",
    action1: "Program değiştirme",
    action2: "Parlaklık ayarı",
    action3: "Ses ayarı",
    action4: "Ekranı kapat",
    action5: "Ekranı aç",
    action6: "Kaynak değiştirme",
    action7: "Röle kapalı",
    action8: "Röle açık",
    action9: "Ekranı kapat",
    action10: "Ekranı aç",
    value: "değer",
    acVa1: "HDMI tercih edilir",
    acVa2: "Asenkron sinyaller",
    acVa3: "Senkronizasyon sinyalleri",
    excTime: "Yürütme süresi",
    dateOk: "Son kullanma tarihi",
    noLimit: "Sınırsız",
    isWeekLi: "Geçerli hafta",
    oper: "işletmek",
    newTem: "Şablon oluştur",
    savTem: "Şablonu kaydet",
    addTem: "Zamanlama şablonu ekleme",
    temName: "Şablonun adı",
    temTip1: "Lütfen şablon için bir ad girin",
    relayOn: "Röle anahtarları",
    timeZoneSe: "Saat dilimi seçimi",
    hdmiSi: "HDMI kaynağı",
    inSin: "Dahili sinyal kaynağı",
    openMulti: "Çoklu ekranda eşzamanlı oynatmayı etkinleştir",
    gps: "GPS senkronizasyonu",
    localW: "LAN senkronizasyonu",
    closeScreen: "Çoklu ekranda eşzamanlı oynatmayı devre dışı bırakın",
    openTimePlay: "Zamanlanmış oynatmayı başlat",
    closeTimePlay: "Zamanlanmış oynatmayı kapat",
    openTime: "Zamanlamayı Başlat",
    onTime: "Önyükleme zamanı",
    offTime: "Kapatma süresi",
    excDate: "Yürütme tarihi",
    closeTime: "Zamanlayıcıyı kapat",
    onlyG: "Yalnızca reklam makinesi cihazlarını destekler",
    Sunday: "Pazar",
    Monday: "Pazartesi",
    Tuesday: "Salı",
    Wednesday: "Çarşamba",
    Thursday: "Perşembe",
    Friday: "Cuma",
    Saturday: "Cumartesi",
    noDeviceSelected: "Hiçbir cihaz seçilmedi",
    group: "Organizasyon",
    onlineNum: "Çevrimiçi miktar",
    offlineNum: "Çevrimdışı miktar",
    totalNum: "Toplam cihaz sayısı",
    noOrderExc: "Henüz hiçbir komut yürütülmedi",
    createTime: "Yaratılış zamanı",
    orderName: "Komut adı",
    aimDevice: "Hedef cihaz",
    orderStatus: "Komut durumu",
    timeOut: "Zaman aşımı geri bildirimi",
    excSuccess: "Yürütme başarılı",
    sent: "Gönderilmiş",
    timeOpenNo: "Zamanlayıcı anahtarı: Henüz veri yok",
    timeOpen: "Zamanlayıcı anahtarı: Açık",
    deviceOff: "Cihaz çevrimdışı",
    timeOpenTip: "Zamanlanmış oynatma açık",
    timeCloseTip: "Zamanlanmış oynatma kapalı",
    programList: "Program listesi",
    playTime: "Program süresi",
    loop: "Döngü oynatma",
    excSta: "Uygulama standardı",
    timingPlay: "Zamanlanmış oynatma",
    playCount: "Oynatma sayısı",
    proDelete: "Programı sil",
    proDeleteTip: "Programı silmek istediğinizden emin misiniz?",
    timePlayOpenTip: "Zamanlanmış oynatma başarıyla açıldı",
    timePlayCloseTip: "Zamanlanmış oynatma başarıyla kapatıldı",
    programChangeTip: "Program değiştirme başarılı",
    programIsPlaying: "Program oynatılıyor",
    powerList: "Yerleşik güç",
    allOpen: "Tam açık",
    allClose: "Tamamen kapalı",
    open: "Açık",
    close: "Kapalı",
    mulCard: "Çok fonksiyonlu kart",
    firstChannel: "Kanal 1",
    secondChannel: "Kanal 2",
    thirdChannel: "Kanal 3",
    fourthChannel: "Kanal 4",
    fifthChannel: "Kanal 5",
    sixthChannel: "Kanal 6",
    seventhChannel: "Kanal 7",
    eighthChannel: "Kanal 8",
    syncToTerminal: "Terminale senkronize et",
    allOpenTip: "Çok işlevli kartı açmayı/kapatmayı onaylıyor musunuz?",
    operComman: "Çalıştırma komutu",
    brigValue: "Hacim",
    method: "Mod",
    speDate: "Tarih belirtin",
    speWeek: "Haftayı belirtin",
    isDateLimit: "Tarih sınırlaması mı var?",
    isWeekLimit: "Bir haftalık kısıtlama mı var?",
    edits: "Düzenlemek",
    timingOn: "Zamanlanmış komut açık",
    timingOff: "Zamanlanmış komut kapalı",
    addTimingCom: "Zamanlanmış komut ekle",
    ban: "Devre dışı bırakmak",
    opend: "Açık",
    closed: "Kapalı",
    timePlayTips: "Zamanlanmış oynatma devam ediyor, değiştirilemiyor",
    addDevice: "Cihaz ekle",
    deviceTypeTip: "Lütfen cihaz tipini seçin",
    key: "Anahtar",
    groupTips: "Organizasyon yapısı boş olamaz",
    least: "Geriye kalan",
    arrangeTip: "Lütfen 0-100 arasında seçim yapın",
    saveSuccess: "Başarıyla kaydet",
    tempExit: "Şablon zaten mevcut, lütfen adını değiştirin",
    command: "Emretmek",
    isSent: "Gönderildi",
    execSuccess: "Başarıyla yürütüldü",
    sented: "Gönderilmiş",
    execFail: "Zaman aşımı geri bildirimi",
    runStatus: "Çevrimiçi ve Açık Ekran ve Oynama",
    timeLimit: "Lütfen bekleyin",
    timeLimitTip: "çalıştırmadan saniyeler önce, kalan",
    seconds: "saniye",
    EditInstruction: "Talimatı Düzenle",
    AddInstruction: "Talimat Ekle"
  },
  PE: {
    Setting: "Ayarlamak",
    Save: "Kaydetmek",
    Release: "Yayınla",
    Quit: "Çıkış",
    ExitEditProgram: "Çıkış, halihazırda düzenlenmiş olan programı silecektir",
    DragMaterial: "Lütfen kaynak dosyayı buraya sürükleyin",
    SaveWait: "Ekran görüntüsü kaydediliyor, lütfen bekleyin...",
    ProgramList: "Program listesi",
    multimedia: "Multimedya",
    AddMultimedia: "Multimedya ekle",
    Insert: "Geçerli konuma ekle",
    properties: "Pencere kaynağı özellikleri",
    materialNull: "Lütfen pencereye kaynak ekleyin",
    Uploaded: "Kaynağı yükle",
    AllLoaded: "Tüm kaynaklar yüklendi",
    materialsLoaded: "Daha fazla kaynak yüklemek için tıklayın",
    Text: "Metin",
    Digital: "Dijital saat",
    Analog: "Analog saat",
    Weather: "Hava durumu",
    Timing: "Sayılıyor",
    Countdown: "Geri sayım",
    StreamMedia: "Medya akışı",
    RSS: "RSS",
    Window: "Pencere",
    Picture: "Resim",
    Video: "Video",
    Delete: "Silmek",
    Webpage: "Web sayfası",
    OneLayerUp: "Bir seviye yukarı",
    OneLayerDown: "Bir seviye aşağı",
    Top: "Üst seviye",
    Bottom: "Alt seviye",
    Full: "Tam ekran",
    HorizontalFull: "Yatay tam ekran",
    VerticalFull: "Dikey tam ekran",
    VerticalDown: "Dikey aşağı",
    VerticalMiddle: "Dikey merkez",
    VerticalTop: "Dikey yukarı",
    HorizontalLeft: "Yatay sol",
    HorizontalCenter: "Yatay merkez",
    HorizontalRight: "Yatay sağ",
    ProgramName: "Program adı",
    Structure: "Organizasyon yapısı",
    DeviceType: "Cihaz türü",
    Resolution: "Çözünürlük",
    CustomResolution: "Özel çözünürlük",
    Device: "Cihaz",
    SelectDevice: "Lütfen bir cihaz seçin",
    SelectTerminal: "Bir yayınlama terminali seçin",
    TerminalName: "Terminal adı",
    DeviceStatus: "Cihaz durumu",
    Offline: "Çevrimdışı",
    AdaptiveScreen: "Uyarlanabilir ekran boyutunda oynatma",
    Tip: "Çabuk",
    Thumbnail: "Küçük resim",
    Name: "İsim",
    version: "Sürümleri <i style=\"color: red;\">(228)</i>'den düşük olan P serisi cihazlar yalnızca zamanlanmış yayınlamayı destekler. Lütfen önce programı kaydedin, Program Yönetimi - Gelişmiş Yayınlama'ya gidin, Zamanlanmış Oynatma'yı seçin, kaydedilen programı ekleyin ve ardından yayınlayın.",
    Title: "Başlık",
    TimerMode: "Zamanlama yöntemi",
    RelativeTime: "Göreceli zaman",
    AbsoluteTime: "Mutlak zaman",
    DisplayMode: "Ekran modu",
    Day: "Gün",
    Hour: "Saat",
    Minutes: "dakika",
    Second: "Saniye",
    EditStyle: "Görüntüleme stili",
    DisplayUsage: "Ekran modu",
    ARow: "Tek satır",
    MultiRow: "Çoklu satırlar",
    FontFamily: "Yazı tipi ayarları",
    BackgroundColor: "Arka plan rengi",
    FontColor: "Yazı tipi rengi",
    PlayTime: "Oynatma süresi",
    Describe: "Açıklama metni",
    HourMark: "Zaman ölçeği",
    HourHand: "Saat",
    MinutesMark: "Dakika ölçeği",
    MinutesHand: "dakika",
    background: "Arka plan",
    secondHand: "Saniye",
    DateAndDay: "Tarih ve hafta",
    Display: "Görüntülemek",
    SelectTimeZone: "Saat dilimini seçin",
    Scale: "Orantılı kısıtlama",
    ConstrainProportions: "Kısıtlı oran",
    EnterTheAnimation: "Giriş animasyonu",
    TheEntryTime: "Giriş süresi",
    Data: "Tarih",
    Time: "Zaman",
    ChineseCalendar: "Ay takvimi",
    Week: "Haftanın günü",
    DateFormat: "Tarih formatı",
    Font: "Yazı tipi",
    Roll: "Taslak",
    FlipOver: "Sayfa dönüşü",
    Motionless: "Hala",
    RollingDirection: "Kaydırma yönü",
    RollingVelocity: "Kaydırma hızı",
    FromLeftToRight: "Soldan sağa",
    FromRightToLeft: "Sağdan sola",
    FromTopToBottom: "Yukarıdan aşağıya",
    FromTheBottomUp: "Aşağıdan yukarıya",
    Attribute: "Nitelikler",
    AttendedMode: "Bağlantı yöntemi",
    EndToEnd: "Uçtan uca bağlanın",
    VolumeAdjust: "Ses ayarı",
    Duration: "Video süresi",
    Address: "Adres",
    City: "Şehir",
    Temp: "Sıcaklık",
    WindPower: "Rüzgar kuvveti",
    Humidity: "Nem",
    DressingIndex: "Pansuman indeksi",
    PlayTheWay: "Oynatma modu",
    TimeFormat1: "00:00:00:00",
    TimeFormat2: "00D00H00M00S"
  }
}